import { PurchaseOrderStatus } from "@redotech/crdb-enums/inventory/purchase-order-status";
import {
  inboundShipmentIdFormat,
  purchaseOrderIdFormat,
  supplierIdFormat,
} from "@redotech/redo-inventory-id";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { instant, plainDate } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

// Purchase order in list view
const PurchaseOrderListItemSchema_ = z.object({
  id: purchaseOrderIdFormat.schema,
  poNumber: z.string(),
  reference: z.string().nullish(),
  supplier: z
    .object({ id: supplierIdFormat.schema, name: z.string() })
    .nullish(),
  status: createEnum(PurchaseOrderStatus),
  tags: z.array(z.string()),
  productCount: z.number().int(),
  expectedCount: z.number().int(),
  receivedCount: z.number().int(),
  shipmentCount: z.number().int(),
  shipments: z.array(
    z.object({
      id: inboundShipmentIdFormat.schema,
      shipmentId: z.string().nullish(),
    }),
  ),
  totalCost: z.number(),
  currency: z.string(),
  createdAt: instant(),
  updatedAt: instant(),
  orderedAt: plainDate().nullish(),
});

export const PurchaseOrderListItemSchema: z.ZodType<PurchaseOrderListItem> =
  PurchaseOrderListItemSchema_;
export interface PurchaseOrderListItem extends z.infer<
  typeof PurchaseOrderListItemSchema_
> {}

export const getPurchaseOrders = {
  name: "getPurchaseOrders" as const,
  input: z.object({
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int(),
    search: z.string().optional(),
    sortBy: createEnum([
      "poNumber",
      "supplierName",
      "reference",
      "createdAt",
      "updatedAt",
      "totalCost",
    ]).optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    purchaseOrders: z.array(PurchaseOrderListItemSchema),
    totalCount: z.number().int(),
  }),
};
